import { idZodSchema } from "@@/shared/id";
import { z } from "zod";
import type {
    MetaContent} from "../meta-content/meta-content";
import {
    metaContentZodSchema,
} from "../meta-content/meta-content";

type ImageReferenceUpdate = {
    _id: string;
    _type: "IMAGE_REFERENCE_UPDATE";
    status: "UPDATE" | "REMOVE";
    isFavourite: boolean;
    meta?: MetaContent;
};

const imageReferenceUpdateZodSchema: z.ZodSchema<ImageReferenceUpdate> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("IMAGE_REFERENCE_UPDATE"),
        status: z.enum(["UPDATE", "REMOVE"]),
        isFavourite: z.boolean(),
        meta: metaContentZodSchema.optional(),
    });

export { imageReferenceUpdateZodSchema };
export type { ImageReferenceUpdate };
